const initialState = {
  activeForm: "form1",
  pageTitle: "Sign Up",
  pageSubTitle: "Register Here",
  formData: {},
};

const changeFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FORM_FILL_UP":
      const { activeForm, pageTitle, pageSubTitle, formData } = action.payload;
      return {
        activeForm,
        pageTitle,
        pageSubTitle,
        formData,
      };

    default:
      return initialState;
  }
};

export default changeFormReducer;
